export const smartJoin = (
  values: Array<any>,
  separators?: {
    separator: string
    lastSeparator: string
  }
) => {
  const { separator = ', ', lastSeparator = ' и ' } = separators || {}

  if (values.length <= 1) {
    return values.join(separator)
  }

  return [values.slice(0, -1).join(separator), values[values.length - 1]].join(lastSeparator)
}
